<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <entities-crud></entities-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EntitiesCrud from './entities/EntitiesCrud';

    export default {

        components: {
            EntitiesCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.clients'),
                    },
                ]
            }
        },
    }
</script>
